// ========================================
// TAX CALCULATION SERVICE
// ========================================
// src/services/invoices/taxCalculationService.ts

export interface TaxCalculation {
  subtotal: number;
  taxRate: number;
  taxAmount: number;
  total: number;
  taxLabel: string;
}

class TaxCalculationService {
  private readonly VN_VAT_RATE = 0.10; // 10% VAT

  /**
   * Calculate Vietnamese VAT (10%)
   * Amount already INCLUDES VAT
   */
  calculateTax(
    amount: number,
    country: string = 'VN',
    userType: 'individual' | 'company' = 'individual'
  ): TaxCalculation {
    // MVP: Only Vietnam VAT
    if (country === 'VN') {
      return this.calculateVNVAT(amount);
    }

    // International: No tax for MVP
    return {
      subtotal: amount,
      taxRate: 0,
      taxAmount: 0,
      total: amount,
      taxLabel: 'Không có VAT (Quốc tế)'
    };
  }

  /**
   * Calculate VN VAT where amount INCLUDES tax
   * Formula: subtotal = amount / (1 + taxRate)
   */
  private calculateVNVAT(amount: number): TaxCalculation {
    const taxRate = this.VN_VAT_RATE;
    const subtotal = amount / (1 + taxRate);
    const taxAmount = amount - subtotal;

    return {
      subtotal: Math.round(subtotal),
      taxRate,
      taxAmount: Math.round(taxAmount),
      total: amount,
      taxLabel: 'VAT (10%)'
    };
  }

  /**
   * Calculate total from subtotal (subtotal does NOT include tax)
   */
  calculateTotalFromSubtotal(subtotal: number): TaxCalculation {
    const taxRate = this.VN_VAT_RATE;
    const taxAmount = subtotal * taxRate;
    const total = subtotal + taxAmount;

    return {
      subtotal,
      taxRate,
      taxAmount: Math.round(taxAmount),
      total: Math.round(total),
      taxLabel: 'VAT (10%)'
    };
  }
}

export const taxCalculationService = new TaxCalculationService();





